import React from 'react';
import PropTypes from 'prop-types';
import './FieldText.sass';

import cx from 'classnames';

export default function FieldText({input, meta: {touched, error} = {}, type, label, className, ...rest}) {
  const displayError = (touched && error);

  switch(type) {
    case 'textarea':
      return (
        <div className={cx('field-text', displayError && 'field-text--error', className)}>
          {label && (
            <label htmlFor={input.name} className="field-text__name">{label}</label>
          )}
          <div className="field-text__input-wrap">
            <textarea {...rest} {...input} className="field-text__input"/>
            {displayError && (<div className="field-text__error-message">{error}</div>)}
          </div>
        </div>
      );
    default:
      return (
        <div className={cx('field-text', displayError && 'field-text--error', className)}>
          {label && (
            <label htmlFor={input.name} className="field-text__name">{label}</label>
          )}
          <div className="field-text__input-wrap">
            <input {...rest} {...input} type={type} className="field-text__input"/>
            {displayError && (<div className="field-text__error-message">{error}</div>)}
          </div>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./components/fields/fieldText/FieldText.js